var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconErrorApi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h35v35H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 65",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M9749.617 18630.879a14.26 14.26 0 0 1-3.62-9.506 14.459 14.459 0 1 1 8.989 13.3l-6.117 2.207z",
  style: {
    stroke: "none"
  },
  transform: "translate(-9742.999 -18604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9750.42 18634.941 4.595-1.658.463.19c1.59.648 3.279.976 5.02.976 3.528 0 6.846-1.361 9.34-3.832a12.93 12.93 0 0 0 3.863-9.244c0-3.49-1.372-6.771-3.863-9.24a13.19 13.19 0 0 0-9.34-3.832 13.18 13.18 0 0 0-9.339 3.832 12.93 12.93 0 0 0-3.862 9.24c0 3.184 1.169 6.254 3.292 8.643l.391.44-.073.583zm-1.552 1.942.748-6.004a14.26 14.26 0 0 1-3.62-9.506c0-7.937 6.492-14.373 14.5-14.373 8.012 0 14.504 6.436 14.504 14.373 0 7.941-6.492 14.377-14.504 14.377-1.951 0-3.811-.38-5.51-1.074z",
  style: {
    fill: "#000",
    stroke: "none"
  },
  transform: "translate(-9742.999 -18604)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1291",
  transform: "translate(-172 -339.758)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v8",
  "data-name": "Line 8",
  style: {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: "1.3px",
    fill: "none"
  },
  transform: "translate(189.5 351.5)"
}), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellipse 43",
  transform: "translate(188.5 362)"
}))));
export default SvgIconErrorApi;